import React from "react";
import { connect } from "react-redux";
import "./index.css";
import SiteConfig from "site-config.json";
import HelpButton from "../helpButton";

const has_footer_img =
  SiteConfig.hasOwnProperty("footer-wrap") &&
  SiteConfig["footer-wrap"].length > 0;
const footerWrap = {
  background: has_footer_img
    ? `url(${SiteConfig["footer-wrap"]}) bottom center repeat-x`
    : SiteConfig["footer-color"],
  height: "175px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between"
};

const footer_logo =
  SiteConfig.hasOwnProperty("footer-logo") &&
  SiteConfig["footer-logo"].length > 0 ? (
    <img
      src={SiteConfig["footer-logo"]}
      alt="footer-logo"
      className="footerLogo"
    />
  ) : null;

const bsuFooter = ({ user, loggedIn }) => {
  const links = [];

  if (user && loggedIn && (user.admin || user.email)) {
    links.push(
      <a key="signout" href={process.env.REACT_APP_API_URL + "/logout"}>
        Sign out
      </a>
    );
  }
  if (!user || !user.admin) {
    if (links.length > 0) {
      links.push(" | ");
    }
    links.push(
      <a key="admin_login" href="/adminlogin">
        Admin Login
      </a>
    );
  }

  return (
    <footer>
      <HelpButton />
      <div className="footerWrap" style={footerWrap}>
        <div className="footerInterior">{footer_logo}</div>
        <div className="footerBottomText justify-content-md-center">
          <div className="col-md-5">
            <p className="footerInfo">{SiteConfig["footer-info"].replace(/YYYY/g, (new Date()).getFullYear())}</p>
          </div>
          <div className="col-md-3">
            <p className="footerLinks">{links}</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

const mapStateToProps = state => ({
  user: state.write_class.user,
  loggedIn: state.write_class.loggedIn
});

export default connect(mapStateToProps)(bsuFooter);



// WEBPACK FOOTER //
// ./src/components/appFooter/index.jsx